import { render } from "./SearchBooksBlock.vue?vue&type=template&id=4bdfff72&scoped=true"
import script from "./SearchBooksBlock.vue?vue&type=script&lang=js"
export * from "./SearchBooksBlock.vue?vue&type=script&lang=js"

import "./SearchBooksBlock.vue?vue&type=style&index=0&id=4bdfff72&lang=scss&scoped=true"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdfff72"]])

export default __exports__